import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip
} from "@mui/material";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";

const ViewDesignEng = (props) => {
    const { open, handleClose, rowData, isLoading } = props;

    const submissionData = rowData?.submissions ? [...rowData.submissions] : [];
    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };


    const calculateDaysRemaining = () => {
        if (!rowData?.targetDate) return "N/A";

        const target = moment(rowData.targetDate);
        const today = moment();
        const days = target.diff(today, 'days');

        return days;
    };

    const daysRemaining = calculateDaysRemaining();
    const isOverdue = daysRemaining !== "N/A" && daysRemaining < 0;



    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {/* <Avatar
                        sx={{
                            width: 40,
                            height: 40,
                            bgcolor: getAvatarColor(rowData?.consultant || ""),
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}
                    >
                        {rowData?.consultant?.[0] || "D"}
                    </Avatar> */}
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Drawing Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: "3px",
                        border: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        p: 2,
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                        }}
                    >
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            fontFamily: "Outfit, sans-serif",
                            color: "#0A0A0C"
                        }}>
                            Drawing Information
                        </Typography>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <CardContent sx={{ pt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Grid container spacing={1}>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Asset:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.projectCode ?? "N/A"}
                                        </Typography>
                                    </Grid>
                                    {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Component</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.component ?? "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Block:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.block ?? "N/A"}
                                        </Typography>
                                    </Grid> */}
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Consultant:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                            <Typography sx={valueStyle}>
                                                {rowData?.consultant ?? "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Discipline:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.discipline ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Stage:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.stage ?? "N/A"}
                                        </Typography>
                                    </Grid> */}

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Drawing Number:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.drgNo ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Drawing Type:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.designType ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Drawing Title:</strong>
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: "18px",
                                            color: "#111827",
                                            fontWeight: 600,
                                            mb: 2,
                                            fontFamily: "Outfit, sans-serif",
                                            padding: "8px",
                                            backgroundColor: "#f8f9fa",
                                            borderRadius: "4px",
                                            borderLeft: "4px solid #0E73F6"
                                        }}>
                                            {rowData?.title ?? "N/A"}
                                        </Typography>
                                    </Grid>


                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={{
                                            ...labelStyle,
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            color: "#374151",
                                            mt: 2,
                                            mb: 1
                                        }}>
                                            <strong>Review Section:</strong>
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Latest Revision Date:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                            <Typography sx={{
                                                ...valueStyle,
                                                // color: isOverdue ? "#d32f2f" : "#388e3c",
                                                // fontWeight: 600
                                            }}>
                                                {rowData?.lastSubmissionDate ?
                                                    moment(rowData.lastSubmissionDate).format("DD MMM YYYY") :
                                                    "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Latest Revision Number:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.lastRevisionNo ?? "N/A"}
                                        </Typography>
                                    </Grid>
                                    {submissionData.length > 0 ? (
                                        submissionData.map((item, index) => (
                                            <Grid
                                                key={item.designTrackerSubmissionId || index}
                                                size={{ xs: 12, sm: 6, md: 6 }}>
                                                <Typography sx={labelStyle}>
                                                    <strong>Review No:{index + 1}</strong>
                                                </Typography>
                                                <Box sx={{
                                                    display: "flex", flexDirection: "column",
                                                    justifyContent: "flex-start", gap: 0, mb: 2
                                                }}>
                                                    <Typography sx={valueStyle}>
                                                        {item?.submissionDate ? `Revision Date: ${moment(item.submissionDate).format("DD MMM YYYY")}` : "N/A"}
                                                    </Typography>
                                                    <Typography sx={{
                                                        fontSize: "15px",
                                                        color: "#111827",
                                                        fontWeight: 500,
                                                    }}>
                                                        {item && `Revision Number : ${item.revisionNo}`}
                                                    </Typography>
                                                </Box>
                                            </Grid >
                                        ))
                                    ) : (
                                        <Typography sx={{
                                            fontSize: "15px",
                                            color: "#111827",
                                            fontWeight: 500,
                                        }}>
                                            No submissions available
                                        </Typography>
                                    )}

                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={{
                                            ...labelStyle,
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            color: "#374151",
                                            mt: 2,
                                            mb: 1
                                        }}>
                                            <strong>Approval Section:</strong>
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Target Date (Drawing Receive):</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                            <Typography sx={{
                                                ...valueStyle,
                                                color: "#111827",
                                                fontWeight: 600
                                            }}>
                                                {rowData?.targetDate ?
                                                    moment(rowData.targetDate).format("DD MMM YYYY") :
                                                    "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Status:</strong>
                                        </Typography>
                                        <Box sx={{ mb: 2 }}>
                                            <StatusBadge status={rowData?.status} />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>GFC Approval Date:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                            <Typography sx={{
                                                ...valueStyle,
                                                color: "#111827",
                                                fontWeight: 600
                                            }}>
                                                {rowData?.gfcApprovalDate ?
                                                    moment(rowData.gfcApprovalDate).format("DD MMM YYYY") :
                                                    "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>GFC Approval Status:</strong>
                                        </Typography>
                                        <Box sx={{ mb: 2 }}>
                                            <StatusBadge status={rowData?.gfcApprovalStatus} />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>IE Approval Date:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                            <Typography sx={{
                                                ...valueStyle,
                                                color: "#111827",
                                                fontWeight: 600
                                            }}>
                                                {rowData?.ieApprovalDate ?
                                                    moment(rowData.ieApprovalDate).format("DD MMM YYYY") :
                                                    "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>IE Approval Status:</strong>
                                        </Typography>
                                        <Box sx={{ mb: 2 }}>
                                            <StatusBadge status={rowData?.ieApprovalStatus} />
                                        </Box>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default ViewDesignEng;